import { MarketGroupsModel } from "../../model";
import { AllOutrightsTabId } from "../../constants";
const getAllOutrightsTabData = (tabName, isAllOutrightsFirst) => {
    return {
        id: AllOutrightsTabId,
        name: tabName,
        outrightSortingKey: isAllOutrightsFirst ? Number.MIN_SAFE_INTEGER.toString() : Number.MAX_SAFE_INTEGER.toString()
    };
};
export const getAllOutrightsTab = (leagueId, isAllOutrightsFirst, tabName) => {
    let tab = new MarketGroupsModel(getAllOutrightsTabData(tabName, isAllOutrightsFirst), leagueId);
    return tab;
};
//# sourceMappingURL=getAllOutrightsTab.js.map